// Service worker registration for the PWA cache + cache cleanup. The reload
// banner is gated SOLELY on SvelteKit's `$updated` store in +layout.svelte —
// this module no longer participates in reload decisions. Keeping the OR'd
// `getSwWaiting()` source AND a `controllerchange → location.reload()`
// listener was the SAY-1xxx double-fire/false-positive bug: a stale waiting
// SW from a previous tab would flip the banner on a fresh load even when no
// new build had been deployed, and a duplicate registerSW() call (HMR /
// re-mount) would attach a second `controllerchange` listener whose
// closure-scoped `reloaded` flag defeated the guard.

let registered = false;

export function registerSW(): void {
	if (registered) return;
	if (!import.meta.env.PROD) return;
	if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
	registered = true;

	navigator.serviceWorker
		.register('/service-worker.js', { type: 'module', updateViaCache: 'none' })
		.then((registration) => registration.update())
		.catch((err) => console.warn('[sw] register failed', err));
}
